import { Box, Button, ButtonDropdown, Checkbox, FormField, Header, Link, Modal, Table, Textarea, TokenGroup } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Pagination from '@cloudscape-design/components/pagination';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import { useEffect, useMemo, useState } from 'react';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../layout';
const _preserve = React.version;

//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiDeleteOutline, mdiFileExcel } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import ConfirmDelete from '../../../../components/extras/ConfirmDelete';
import SelectPaging from '../../../../components/selects/selectPaging';
import SelectUser from '../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemUser } from '../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, exportToExcel, formatCurrency, getCookie, getUrlVersion, getUserGroup, setData, setLoading, setParameters } from '../../../commons/functions';


type ItemIds = {
    label: string;
    dismissaLabel: string;
    idUser: number;
}
export const MasterGroupsUsers = () => {
    const { menu, parameters, data } = useGlobalState();


    //const storeAdmin = useStoreAdmin();


    const [users, setUsers] = useState<ItemUser[]>([]);
    const [idUsers, setIdUsers] = useState<string>('');
    const [emptyGroup, setEmptyGroup] = useState(false);
    const [idUsersTokens, setIdUsersTokens] = useState<ItemIds[]>([]);

    const [filteringText, setFilteringText] = useState("");
    const [idGroup, setIdGroup] = useState(0);
    const [masive, setMassive] = useState(0);
    const [confirm, setConfirm] = useState(0);

    useEffect(() => {
        const result = idUsers.replace(".", "").toUpperCase().split(/[^0-9kK-]+/);
        const matchedItems: ItemIds[] = data.users
            .filter((user: { idUser: { toString: () => string; }; RUT: string; }) => result.includes(user.idUser.toString()) || result.includes(user.RUT))
            .map((user: { displayName: any; idUser: any; }) => ({
                label: user.displayName,
                idUser: user.idUser
            }));
        setIdUsersTokens(matchedItems)

    }, [idUsers]);
    const handleUserAdd = async (idUser: number) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/groups/add',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idGroup: idGroup, idUser: idUser }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code == 0) {
                const localUser = dataWeb.user
                if (localUser) {
                    if (!users.some(u => u.idUser === localUser.idUser)) {
                        setUsers(prev => [...prev, localUser]);
                    }
                }
            }
        } catch (error: any) {
            //addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleUserRemove = async (idUser: number) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/groups/remove',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idGroup: idGroup, idUser: idUser }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code == 0) {
                if (users.some(u => u.idUser === idUser)) {
                    setUsers(prev => prev.filter(u => u.idUser !== idUser));
                }
            }
        } catch (error: any) {
            //addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }

    const handleAssing = async (isEmpty: boolean) => {
        try {
            const idu = idUsersTokens.map((item) => item.idUser);
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/groups/addbatch',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idGroup: idGroup, idUsers: idu, empty: isEmpty ? 1 : 0 }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code == 0) {
                handleGetUsersFilter(idGroup);
                setIdUsers('');
                setMassive(0);
                setEmptyGroup(false);
                setConfirm(0);
            }
        } catch (error: any) {
            //addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleGetUsersFilter = async (idGroup: number) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/reports/users/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idGroup: idGroup, isActiveUser: 1, isDeleteUser: 0 }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code == 0) {

                setUsers(dataWeb.users);
            }
        } catch (error: any) {
            //addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }


    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");

            if (id) {
                handleGetUsersFilter(parseInt(id));
                setIdGroup(parseInt(id));
            }
            else {
                setUsers([]);
                setIdGroup(0);
            }
        };
        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    // 1. Always holds ALL users, perfectly sorted. (Use this for Excel export)
    const sortedUsers = useMemo(() => {
        return [...users].sort((a, b) => {
            const lastNameCompare = a.lastName.localeCompare(b.lastName, 'es', { sensitivity: 'base' });
            if (lastNameCompare !== 0) {
                return lastNameCompare;
            }
            return a.name.localeCompare(b.name, 'es', { sensitivity: 'base' });
        });
    }, [users]); // 🔄 Re-runs only when users are added or removed

    // 2. Holds the filtered version of the sorted list. (Use this for UI/Autosuggest options)
    const filteredUsers = useMemo(() => {
        if (!filteringText || filteringText.trim() === "") {
            return sortedUsers;
        }

        const search = filteringText.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        return sortedUsers.filter(user => {
            const fullName = `${user.name} ${user.lastName}`.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            return fullName.includes(search);
        });
    }, [sortedUsers, filteringText]); // 🔄 Re-runs when you type OR when sortedUsers changes
    const [currentPageIndex, setCurrentPageIndex] = useState(1)
    const paginated = filteredUsers.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);


    return (
        <CustomAppLayout
            toolsHide


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    {users && (
                        <><Header variant="h2"
                            counter={users.length > 0 ? users.length : undefined}
                            description={`Grupo: ${getUserGroup(idGroup, data)?.group || ""}`}
                            actions={
                                <ButtonDropdown
                                    onItemClick={({ detail }) => {
                                        if (detail.id === "massive") {
                                            setMassive(1);
                                        } else if (detail.id === "empty") {
                                            setConfirm(1);
                                        }
                                    }}
                                    items={[
                                        { text: "Asignador masivo", id: "massive" },
                                        { text: "Vaciar grupo", id: "empty", disabled: users.length === 0 },
                                    ]}
                                >
                                    Acciones
                                </ButtonDropdown>}
                        >Usuarios</Header>
                            <Table
                                variant='embedded'
                                stickyHeader
                                filter={
                                    <SpaceBetween size="xs" direction="vertical">
                                        <SpaceBetween size="xs" direction="horizontal">
                                            <FormField label="Filtrar usuarios">
                                                <TextFilter filteringText={filteringText} onChange={({ detail }) => setFilteringText(detail.filteringText)} />
                                            </FormField>

                                            <FormField label="&nbsp;">
                                                <Button style={{ root: btnIconForm }} disabled={sortedUsers.length === 0} onClick={() => exportToExcel(sortedUsers, `Usuarios Grupo ${getUserGroup(idGroup, data)?.group || ""}`, "Usuarios")}><Icon path={mdiFileExcel} size={1} /></Button>
                                            </FormField>
                                            <FormField label="Agregar usuario">
                                                <SelectUser value={0}
                                                    placeholder={"Agregar usuario"}
                                                    onConfirm={(user) => {
                                                        if (user) {
                                                            handleUserAdd(user.idUser);
                                                        }
                                                    }} />
                                            </FormField>
                                        </SpaceBetween>
                                    </SpaceBetween>
                                }


                                pagination={

                                    <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                        {users.length > parameters.pageSize && (
                                            <Pagination
                                                currentPageIndex={currentPageIndex}
                                                pagesCount={Math.ceil(users.length / parameters.pageSize)}
                                                onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                            />
                                        )}

                                        {users.length > 0 && (
                                            <SelectPaging onSelect={(pageSize) => {
                                                setCurrentPageIndex(1);
                                                setParameters({ ...parameters, pageSize: pageSize });
                                            }} />
                                        )}
                                    </SpaceBetween>
                                }

                                columnDefinitions={[
                                    {
                                        id: 'name',
                                        header: 'Apellido/Nombre',
                                        cell: (item) => <FormField label={item.lastName}>{item.name}</FormField>,
                                    },
                                    {
                                        id: 'old',
                                        header: 'ANT',
                                        cell: (item) => item.membership,
                                        width: 50,
                                    },
                                    {
                                        id: 'balance',
                                        header: 'Saldo',
                                        cell: (item) => <Box float="right">{formatCurrency(item.balance, "CLP")}</Box>
                                    },
                                    {
                                        id: 'delete',
                                        header: '',
                                        width: 50,
                                        cell: (item) => <Link onClick={() => {
                                            handleUserRemove(item.idUser);

                                        }}><Icon path={mdiDeleteOutline} size={1} /></Link>
                                    },
                                ]}
                                items={paginated}
                            />
                        </>
                    )}
                    <Modal visible={masive != 0} onDismiss={() => {
                        setMassive(0)
                        setEmptyGroup(false);
                    }} closeAriaLabel="Close modal" header="Asignador masivo de usuarios" footer={
                        <Box>
                            <Box float="left">
                                <Button variant="link" onClick={() => setMassive(0)}>Cerrar</Button>
                            </Box>
                            <Box float="right">
                                <Button variant="primary" onClick={() => handleAssing(emptyGroup)}
                                    disabled={idUsersTokens.length === 0}
                                >Asignar</Button>
                            </Box>
                        </Box>
                    }>

                        <FormField
                            constraintText={"Al pegar los nuevos elementos se generará un listado de usuarios seleccionados"}
                            label={'Identificación de usuarios'}
                            info={
                                idUsers !== "" && (
                                    <Link onClick={() => {
                                        setIdUsers('');
                                    }}>Limpiar listado</Link>
                                )
                            }
                        >
                            <Textarea
                                onChange={({ detail }) => {
                                    setIdUsers(detail.value.replace(".", "").toUpperCase().split(/[^0-9kK-]+/).join(" "));
                                }}
                                value={idUsers}
                                placeholder="Pegar RUTs o ID de usuarios"
                            />

                        </FormField>
                        <TokenGroup
                            readOnly
                            onDismiss={({ detail: { itemIndex } }) => {
                                return
                            }}
                            items={idUsersTokens}
                            limit={3}
                        />
                        <Checkbox checked={!!emptyGroup} onChange={({ detail }) => setEmptyGroup(detail.checked)} >Vaciar grupo antes de asignar los usuarios</Checkbox>
                    </Modal>
                    <ConfirmDelete
                        header={'Vaciar grupo de usuarios'}
                        show={confirm == 1} confirmWord={'confirmar'} action={'Vaciar'} warning={'¿Está seguro de querer vaciar el grupo?'}
                        onDismiss={() => setConfirm(0)}
                        onConfirm={() => {
                            setIdUsers('');
                            setIdUsersTokens([]);
                            setEmptyGroup(true);
                            handleAssing(true);
                        }}

                    />
                </>
            }
        />
    );
}
